import { createAsyncActions } from '@wahaaabello/redux-async-actions';
import { PagesReducerPayload, RootState } from '../../../types';

const [
  fetchHomePageRequest,
  fetchHomePageSuccess,
  fetchHomePageFailure
] = createAsyncActions<RootState, PagesReducerPayload>('FETCH_HOME_PAGE');

const [
  fetchUserPageRequest,
  fetchUserPageSuccess,
  fetchUserPageFailure
] = createAsyncActions<RootState, PagesReducerPayload>('FETCH_USER_PAGE');

const [
  fetchPageRequest,
  fetchPageSuccess,
  fetchPageFailure
] = createAsyncActions<RootState, PagesReducerPayload>('FETCH_PAGE');

const [fetchSafelocksRequest] = createAsyncActions('FETCH_SAFELOCKS');
const [fetchTargetsRequest] = createAsyncActions('FETCH_TARGETS');
const [fetchInvestmentsListRequest] = createAsyncActions(
  'FETCH_INVESTMENTS_LIST'
);

const pagesActions = {
  fetchHomePageRequest,
  fetchHomePageSuccess,
  fetchHomePageFailure,
  fetchUserPageRequest,
  fetchUserPageSuccess,
  fetchUserPageFailure,
  fetchPageRequest,
  fetchPageSuccess,
  fetchPageFailure,
  fetchSafelocksRequest,
  fetchTargetsRequest,
  fetchInvestmentsListRequest
};

export default pagesActions;
